import { camelCase } from "lodash";
import { useMemo } from "react";
export function useCamelCase(text) {
    return useMemo(function() {
        return camelCase(text || '');
    }, [
        text
    ]);
}

//# sourceMappingURL=useCamelCase.js.map